import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from "redux-form";
import {renderTextField} from "./inputs/TextFeaild";
import {renderSelectField} from "./inputs/SelectField";

export class RegulationForm extends React.Component {

    render() {

        const {handleSubmit, errors, categories} = this.props;

        console.log(errors)

        return (
            <form onSubmit={handleSubmit}>

                <Field name="sorts"
                       label="管理番号"
                       err={errors.sorts}
                       component={renderTextField}
                       type="number"/>

                <Field name="name"
                       label="法令チェック項目"
                       err={errors.name}
                       component={renderTextField}
                       type="text"/>

                <Field name="regulation_category_id"
                       label="カテゴリー"
                       err={errors.regulation_category}
                       data={categories}
                       component={renderSelectField}
                       type="text"/>

                <Field name="description"
                       multiline
                       rows={1}
                       rowsMax={4}
                       label="補足"
                       err={errors.description}
                       component={renderTextField}
                       type="text"/>

            </form>
        )
    }
}

RegulationForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
};

RegulationForm = reduxForm({
    form: 'regulation'
})(RegulationForm);


// WEBPACK FOOTER //
// ./src/forms/regulation.js